module.exports = __webpack_public_path__ + "02_glasses_brown.13ffa486.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer4/02_glasses_brown.png
// module id = yI2j
// module chunks = 0